import './app.scss'
import { useEffect, useState } from 'react'
import { initializeApp } from './app-initializer.ts'
import { AuthWrapper } from '../auth/auth-provider-factory.tsx'
import AppHeader from './app-header.tsx'
import AppContainer from './app-container.tsx'
import { AxiosInterceptor } from '../../api/interceptor.tsx'
import { FeatureFlagsProvider } from '../shared/feature-flags-context'
import { FeatureFlagDebugPanel } from '../dev-tools/feature-flag-debug-panel.tsx'

export default function App() {
  const [isInitialized, setIsInitialized] = useState(false)
  const [interceptorReady, setInterceptorReady] = useState(false)

  useEffect(() => {
    initializeApp()
      .then(() => setIsInitialized(true))
      .catch((e) => console.error('Failed to initialize app', e))
  }, [])

  const onReady = () => {
    setInterceptorReady(true)
  }

  return (
    <AxiosInterceptor onInterceptorReady={onReady}>
      {interceptorReady && (
        <AuthWrapper>
          <FeatureFlagsProvider>
            <AppHeader />
            <AppContainer isInitialized={isInitialized} />
            <FeatureFlagDebugPanel />
          </FeatureFlagsProvider>
        </AuthWrapper>
      )}
    </AxiosInterceptor>
  )
}
